import React, { useEffect, useState } from "react";
import { MessageType, Product } from "../constants";
import "../modal.css";
import HealthSinglePlanSelection from "./Health/SinglePlanSelection";
import TravelSinglePlanSelection from "./Travel/SinglePlanSelection";

export default function SinglePlanSelection({ message, sendMessage, userId, GAEvent, productId }) {
    const [openModal, setOpenModal] = useState("")
    const [selectedPlan, setSelectedPlan] = useState("")
    const [planList, setPlanList] = useState([])
    const [content, setMessageContent] = useState("")
    const [selectedInsurer, setSelectedInsurer] = useState("")
    const [insurerList, setInsurerList] = useState({})

    // const content = JSON.parse(message.content)
    useEffect(() => {
        let insurers = {}
        for (let plan of planList) {
            insurers[plan.supplier_id] = {
                "supplier_id": plan.supplier_id,
                "supplier_name": plan.supplier_name,
                "ImageUrl": plan.ImageUrl
            }
        }
        console.log(insurers)
        setInsurerList(insurers)
    }, [planList])

    useEffect(() => {
        console.log(message)
        if (message && message.type.toLowerCase() === MessageType.json && message.content) {
            let content = JSON.parse(message.content)
            setMessageContent(content)
            setPlanList(content.choices)
        }
    }, [message])
    GAEvent({ eventAction: "view-feature-plans-list", eventLabel: "visible" })
    useEffect(() => {
        // let content = JSON.parse(message.content)
        if (content.selected && message.from === userId) {
            setOpenModal("")
        }
        else {
            setOpenModal("open")
        }
    }, [message])
    const selectPlan = (plan, checked) => {
        if (checked) {
            setSelectedPlan(plan)
        } else if (!checked) {
            setSelectedPlan("")
        }
    }
    const handleSearch = (planName) => {
        if (content && content.choices) {
            let list = content.choices.filter((obj) =>
                obj.plan_name &&
                    obj.plan_name.toLowerCase().includes(planName.toLowerCase().trim())
                    ? true
                    : false
            );
            setPlanList(list)
        }
    }
    // handleSubmit
    const handleSubmit = () => {
        let resp = { "plan": [selectedPlan], "type": content.type }
        let json = {
            content: JSON.stringify(resp),
            refMessageId: message.messageId,
            type: MessageType.json,
        };
        sendMessage(json);
        GAEvent({ eventAction: "feature-plan-list-selected", eventLabel: selectedPlan ? selectedPlan.plan_name : null })

    }
    const SearchPlan = (planName) => {
        if (content && content.choices) {
            let list = content.choices.filter((obj) =>
                obj.plan_name &&
                    (obj.plan_name.toLowerCase().includes(planName.toLowerCase().trim()))
                    ? true
                    : false
            );
            setPlanList(list)
        }
    }
    const SearchInsurer = (insurerName) => {
        if (content && content.choices) {
            let list = content.choices.filter((obj) =>
                obj.plan_name &&
                    (obj.supplier_name.toLowerCase().includes(insurerName.toLowerCase().trim()))
                    ? true
                    : false
            );
            setPlanList(list)
        }
    }


    return (
        <>
            {productId === Product.Health ?
                <HealthSinglePlanSelection
                    handleSearch={handleSearch}
                    handleSubmit={handleSubmit}
                    planList={planList}
                    openModal={openModal}
                    selectedPlan={selectedPlan}
                    selectPlan={selectPlan}
                    setSelectedInsurer={setSelectedInsurer}
                    insurerList={insurerList}
                    selectedInsurer={selectedInsurer}
                    SearchPlan={SearchPlan}
                    SearchInsurer={SearchInsurer}
                />
                : null}
            {productId === Product.Travel ?
                <TravelSinglePlanSelection
                    handleSearch={handleSearch}
                    handleSubmit={handleSubmit}
                    planList={planList}
                    openModal={openModal}
                    selectedPlan={selectedPlan}
                    selectPlan={selectPlan}
                />
                : null}
        </>
    );
}
